import { lazy } from 'react';

export const LoginPage = lazy(() => import('./LoginPage'));
export const GuestLoginPage = lazy(() => import('./GuestLoginPage'));
export const GuestCheckoutPage = lazy(() => import('./GuestCheckoutPage'));
export const EmailSubmissionPage = lazy(() => import('./EmailSubmissionPage'));
export const PasswordValidationPage = lazy(
  () => import('./PasswordValidationPage'),
);
export const AccountCreationPage = lazy(() => import('./AccountCreationPage'));
export const PasswordSignUpPage = lazy(() => import('./PasswordSignUpPage'));
export const ForgottenPasswordPage = lazy(
  () => import('./ForgottenPasswordPage'),
);
export const ResetPasswordPage = lazy(
  () => import('./ResetPasswordPage/ResetPasswordPage'),
);

export const CheckoutSignUpPage = lazy(() => import('./CheckoutSignUpPage'));
export const RedirectPage = lazy(() => import('./RedirectPage'));
